import React from 'react';
import { Trans } from 'react-i18next';
import { CuringCondition } from '../../../modules/backend/openapi/api-types';
import { Typography } from '../../../visual-components/typography/typography';
import { notNil } from '../../../core/helpers/is-nil';
import { makeAccessorColumnBuilder } from '../../../modules/data-table/helpers';
import { DataTable } from '../../../modules/data-table/data-table';
import { createColumns } from '../../../modules/data-table/create-columns';
import { TableLayout } from '../../../visual-components/table-layout/table-layout';
import { Table } from '../../../visual-components/table/table/table';
import { TableCellUnit } from '../../../visual-components/table/table-cells/table-cell-unit/table-cell-unit';
import styles from './curing-condition-info.module.scss';

type Props = {
  image: string | null;
  curingNote: string | null;
  curingCondition: CuringCondition[];
};

export const CuringConditionInfo: React.FC<Props> = ({ image, curingNote, curingCondition }) => {
  const createAccessorColumn = makeAccessorColumnBuilder<CuringCondition>();
  const colDef = [
    createAccessorColumn('objectTemperature', {
      headerLabel: (
        <span>
          <Trans i18nKey="articleDetail.curingCondition.objectTemperature">
            <sub />
          </Trans>
        </span>
      ),
      renderCell: ({ value, row }) => (
        <TableCellUnit highlight={row.original.recommendation} unitLabel={value.unit} value={value.value} />
      ),
    }),
    createAccessorColumn('minimumDuration', {
      headerLabel: (
        <span>
          <Trans i18nKey="articleDetail.curingCondition.minimumDuration">
            <sub />
          </Trans>
        </span>
      ),
      renderCell: ({ value, row }) => (
        <TableCellUnit highlight={row.original.recommendation} unitLabel={value.unit} value={value.value} />
      ),
    }),
    createAccessorColumn('maximumDuration', {
      headerLabel: (
        <span>
          <Trans i18nKey="articleDetail.curingCondition.maximumDuration">
            <sub />
          </Trans>
        </span>
      ),
      renderCell: ({ value, row }) => (
        <TableCellUnit highlight={row.original.recommendation} unitLabel={value.unit} value={value.value} />
      ),
    }),
  ];

  return (
    <div className={styles.root}>
      <div className={styles.column}>
        <DataTable
          data={curingCondition}
          columns={createColumns({
            colDef,
            rowIdentifierColumnId: 'objectTemperature',
          })}
        >
          {(props) => (
            <>
              <TableLayout table={<Table {...props} label="user" />} />
            </>
          )}
        </DataTable>
        <Typography variant="maintext">{curingNote}</Typography>
      </div>
      <div className={styles.column}>{notNil(image) ? <img alt="" className={styles.media} src={image} /> : null}</div>
    </div>
  );
};
